import { render } from "./NotLogged.vue?vue&type=template&id=56074b8d"
import script from "./NotLogged.vue?vue&type=script&lang=js"
export * from "./NotLogged.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__